import { Controller } from "@hotwired/stimulus";
const csrfToken = document.querySelector("meta[name=\"csrf-token\"]")?.content || "";
// Connects to data-controller="turbo-submit"
export default class TurboSubmitController extends Controller {

  submitContent(e) {
    e.preventDefault();

    const phoneInput = this.element.querySelector("input[type=\"tel\"]");
    if (phoneInput && !phoneInput.disabled) {
      const phoneController = this.application.getControllerForElementAndIdentifier(phoneInput, "phone-number");
      if (phoneController && !phoneController.iti.isValidNumber()) {
        phoneController.validateInput();
        return;
      }
    }

    if ($(e.currentTarget).data("isUsernameForm") === "usernameForm") {
      let truck_modal = document.getElementById("shareRecipeModal");
      const modal = bootstrap.Modal.getInstance(truck_modal);
      modal.hide();
    }
    if ($(e.target).closest("button").data("requires-users") === true && $("[name='live_stream[user_ids][]']").length == 0) {
      $(this.element).valid();
      $(".target_people_error").removeClass("d-none");
      return;
    }
    if ($(this.element).valid()) {
      let btnHtml = "";
      btnHtml = $(e.target).html();

      if ($(e.currentTarget).hasClass("show-loading")) {
        this.toggleButtonLoader(true);
      }
      this.url = this.element.getAttribute("action");
      this.method = this.element.getAttribute("method");
      let data = new FormData(this.element);

      let params = {
        method: this.method,
        headers: {
          "X-CSRF-Token": csrfToken,
          Accept: "text/vnd.turbo-stream.html, text/html, application/xhtml+xml"
        }
      };
      if (this.method === "post") {
        params["body"] = data;
      }

      fetch(this.url, params).then(r => {
        $(e.target).prop("disabled", false).html(btnHtml);

        if (r.ok && !r.redirected) {
          return r.text();
        } else {
          if (r.redirected) {
            if (this.element.dataset.isUserform) {
              Swal.fire({
                customClass: {
                  popup: "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
                  htmlContainer: "text-black-paint text-white"
                },
                animation: false,
                html: "Username updated successfully.",
                icon: "success",
                showCloseButton: true,
                buttonsStyling: false,
                showConfirmButton: false,
                timer: 1000 + "Username updated successfully.".split(" ").length * 1000,
              }).then((result) => {
                globalThis.location.href = r.url;
              });
              return;
            }
            globalThis.location.href = r.url;
          }
          return r.text();
        }
      })
        .then(response => {
          if (!response) {
            this.toggleButtonLoader(false);
            return;
          }

          if (/target="content_error"/.exec(response) || /target="error"/.exec(response)) {
            $("#content_error").find("p").html(" ");
          }
          Turbo.renderStreamMessage(response);
          this.toggleButtonLoader(false);
        })
        .catch(error => {
          console.error(error);
          this.toggleButtonLoader(false);
        });
    }
  }

  serializeForm = function (form) {
    let obj = {};
    let formData = new FormData(form);
    for (let [key, value] of formData) {
      if (obj[key] === undefined) {
        obj[key] = value;
      } else {
        if (!Array.isArray(obj[key])) {
          obj[key] = [obj[key]];
        }
        obj[key].push(value);
      }
    }
    if (obj["user[phone_no]"]) {
      obj["user[phone_no]"] = obj["user[phone_no]"][0];
    }
    return obj;
  };

  toggleButtonLoader(isLoading) {
    const $button = $(this.element).find(".show-loading");

    $button.prop("disabled", isLoading);
    $button.find(".btn-text").attr("style", isLoading ? "display:none !important;" : "");
    $button.find(".button-loader-spinner").toggleClass("d-none", !isLoading);

    $(this.element).toggleClass("disabled-form", isLoading);
  }
}
